import { mapToUserGroups } from "../../helpers/GlobalMapper";
const API_URL = `${process.env.REACT_APP_API_URL}`;

export const fetchUsersGroups = async (accessToken: string, tenantID: number) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_GROUP_API}?tenantId=${tenantID}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch users.");
    }

    const data = await response.json();
    return mapToUserGroups(data);
    // return response.json();
  } catch (error) {
    throw error;
  }
};

// Add User Group function
export const addUserGroup = async (userGroup: any, accessToken: string, tenantID: number) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_GROUP_ADD_API}?tenantId=${tenantID}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userGroup),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add user group.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

// Update User Group function
export const updateUserGroup = async (userGroup: any, accessToken: string, tenantID: number) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_GROUP_UPDATE_API}?tenantId=${tenantID}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userGroup), // Send the whole quickLink object
      }
    );

    if (!response.ok) {
      const errorText = await response.text(); // Capture error message
      console.error("API Error Response:", errorText);
      throw new Error("Failed to update user group.");
    }
    

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

// Delete User Group function
export const deleteUserGroup = async (
  userGroupID: number,
  accessToken: string,
  tenantID: number,
  DeletedBy: number,
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_USER_GROUP_DELETE_API}?groupId=${encodeURIComponent(userGroupID)}&tenantId=${tenantID}&deletedBy=${DeletedBy}`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete user group.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};
